import * as React from 'react';

import styles from './Error.module.styl';

interface IProps {
  children: React.ReactNode;
}

export const Error = (props: IProps) => (
  <div className={styles.root}>{props.children}</div>
);
